<mat-nav-list class="hamburger-menu-list-container">
  @for (item of menuItems; track item.displayName; let i = $index) {
    <app-side-menu-item [item]="item" (nav)="onSidenavNavRequest($event)"> </app-side-menu-item>
  }
</mat-nav-list>
